import getTopics from 'services/apiHelpers/getTopics';
import { Block } from 'factories/block';

export default () => {
  return getTopics().filter((t: Block) => {
    return t?.props?.asAssessment;
  });
};
